import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../hooks/useAuthStore';
import { WorkspaceShell, type WorkspaceNavItem } from './WorkspaceShell';

const CLIENT_NAV: WorkspaceNavItem[] = [
  { to: '/dashboard', label: 'Home', icon: '🏠', end: true },
  { to: '/care/find', label: 'Find', icon: '🔍' },
  { to: '/sessions', label: 'Sessions', icon: '📅' },
  { to: '/messages', label: 'Messages', icon: '💬' },
  { to: '/care/resources', label: 'Resources', icon: '🌿' },
  { to: '/tools', label: 'More', icon: '🧰' },
  { to: '/journal', label: 'Journal', icon: '📓' },
  { to: '/progress', label: 'Progress', icon: '📈' },
  { to: '/badges', label: 'Badges', icon: '🏅' },
  { to: '/referrals', label: 'Referrals', icon: '🎁' },
  { to: '/profile', label: 'Profile', icon: '👤' },
];

export function ClientWorkspaceLayout() {
  const { user } = useAuthStore();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'client') return <Navigate to="/" replace />;

  return (
    <WorkspaceShell title="MyLighthouse" subtitle="Licensed care, in naira." nav={CLIENT_NAV} />
  );
}
